import { FormRow, Range } from "@omnabase/ui";
import { INVESTIGATION_EFFORT_MAX_LEVEL, effortToStop, investigationEffortBand, stopToEffort, type InvestigationEffort } from "@omnabase/shared";

/** Investigation effort (the founder, 2026-10-16): the band's label and sentence with the level's credits, and the slider under them. The
 *  slider's stops are 1 to 20 credits and one last stop, "Whatever it takes" (stored as "max"). Settings › AI (Capabilities) and a project's AI
 *  tab draw it; a member never gets it (they read the level in words). */
const creditsOf = (level: InvestigationEffort) => (level === "max" ? "Whatever it takes" : `${level} ${level === 1 ? "credit" : "credits"}`);

export function EffortSlider({ level, label, onChange, disabled, cost }: { level: InvestigationEffort; /** the slider's accessible name */ label: string; onChange: (level: InvestigationEffort) => void; disabled?: boolean; /** on the workspace's own key (2026-10-19): the stop's cost in euros instead of its credits */ cost?: string }) {
  const band = investigationEffortBand(level);
  return (
    <>
      <FormRow label={band.label} help={band.line}><span className="ob-effort-value">{cost ?? creditsOf(level)}</span></FormRow>
      <div className="ob-form-row__control ob-form-row__control--wide">
        <Range value={effortToStop(level)} min={1} max={INVESTIGATION_EFFORT_MAX_LEVEL + 1} step={1} onChange={(v) => onChange(stopToEffort(v))} label={label} disabled={disabled} />
      </div>
    </>
  );
}
